_ = require('lodash')

class DetailedAnalysisCtrl
  constructor: (@$scope, ScoreCardAPIService, $routeParams) ->
    @goal = _.mapValues @$scope.$parent.goalSettings, (val) -> if _.isNull val then "-" else val
    params =
      user_id: $routeParams.user_id
    ScoreCardAPIService.getAllMembers(params).then (data) =>
      @all_members = data

    @$scope.$on "myAnalysisUpdated.gnp.analysis", (event, myAnalysis) =>
      # null * 100 -> 0, but we want to distinguish null from 0
      @my_avg = _.mapValues myAnalysis.my_avg, (val) -> if _.isNull val then "-" else val
      @best_score = _.mapValues myAnalysis.best_score, (val) -> if _.isNull val then "-" else val
      @worst_score = _.mapValues myAnalysis.worst_score, (val) -> if _.isNull val then "-" else val

DetailedAnalysisCtrl.$inject = [
  '$scope'
  'ScoreCardAPIService'
  '$routeParams'
]

module.exports = DetailedAnalysisCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/analysis/detailed-analysis/detailed-analysis-controller.coffee